export const getNextTriStateValue = (
    currentValue: boolean | null | undefined,
    canBeNull: boolean,
    canBeUndefined: boolean
): boolean | null | undefined => {
    // Case 1: true/false (required, non-optional)
    if (!canBeNull && !canBeUndefined) {
        return currentValue === true ? false : true;
    }

    // Case 2: true/false/null (optional, required)
    if (canBeNull && !canBeUndefined) {
        switch (currentValue) {
            case true:
                return false;
            case false:
                return null;
            default: // null
                return true;
        }
    }

    // Case 3: true/false/undefined (non-optional, not required)
    if (!canBeNull && canBeUndefined) {
        switch (currentValue) {
            case true:
                return false;
            case false:
                return undefined;
            default: // undefined
                return true;
        }
    }

    // Case 4: true/false/null/undefined (optional, not required)
    switch (currentValue) {
        case true:
            return false;
        case false:
            return null;
        case null:
            return undefined;
        default: // undefined
            return true;
    }
};
